import { StickyHeader } from "@/components/ui/StickyHeader";

interface SummaryHeaderProps {
  onClose: () => void;
}

export function SummaryHeader({ onClose }: SummaryHeaderProps) {
  return (
    <StickyHeader
      title="Challenge Summary"
      className="bg-[#0c1c0c]/90! backdrop-blur-xl border-b border-white/5 [&_h2]:text-white"
      leftContent={
        <button
          onClick={onClose}
          className="flex size-10 items-center justify-center rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
        >
          <span className="material-symbols-outlined text-white">close</span>
        </button>
      }
    />
  );
}
